/******/
(() => { // webpackBootstrap
    /******/
    "use strict";
    /******/
    var __webpack_modules__ = ({

        /***/ "../src/js/custom/form.js":
        /*!*********************************!*\
          !*** ../src/js/custom/form.js ***!
          \*********************************/
        /***/ ((module) => {


// Class definition
            var KTForm = function () {
                // Public methods
                return {
                    init: function () {
                        $(".input-datepicker").flatpickr({
                            dateFormat: "Y-m-d"
                        });
                        $(".input-datetimepicker").flatpickr({
                            enableTime: true,
                            dateFormat: "Y-m-d H:i",
                        });
                    }
                }
            }();

// Webpack support
            if (true) {
                module.exports = KTForm;
            }

// On document ready
            KTUtil.onDOMContentLoaded(function () {
                KTForm.init();
            });


            /***/
        })

        /******/
    });
    /************************************************************************/
    /******/ 	// The module cache
    /******/
    var __webpack_module_cache__ = {};
    /******/
    /******/ 	// The require function
    /******/
    function __webpack_require__(moduleId) {
        /******/ 		// Check if module is in cache
        /******/
        var cachedModule = __webpack_module_cache__[moduleId];
        /******/
        if (cachedModule !== undefined) {
            /******/
            return cachedModule.exports;
            /******/
        }
        /******/ 		// Create a new module (and put it into the cache)
        /******/
        var module = __webpack_module_cache__[moduleId] = {
            /******/ 			// no module.id needed
            /******/ 			// no module.loaded needed
            /******/            exports: {}
            /******/
        };
        /******/
        /******/ 		// Execute the module function
        /******/
        __webpack_modules__[moduleId](module, module.exports, __webpack_require__);
        /******/
        /******/ 		// Return the exports of the module
        /******/
        return module.exports;
        /******/
    }

    /******/
    /************************************************************************/
    /******/
    /******/ 	// startup
    /******/ 	// Load entry module and return exports
    /******/ 	// This entry module is referenced by other modules so it can't be inlined
    /******/
    var __webpack_exports__ = __webpack_require__("../src/js/custom/form.js");
    /******/
    /******/
})()
;
//# sourceMappingURL=form.js.map
